const sound = require('../../../assets/message_tone.mp3');

export const playNotificationSound = () => new Audio(sound).play().catch(() => console.log('new message sound...'));